module.exports = __webpack_public_path__ + "26459542bcd447d9.otf";